import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import classNames from 'classnames';

const InfoPanel = ({
  className = '',
  message,
  id = '',
  color = 'text-blue',
  size = 'sm',
  showIcon = true,
}) => (
  <div className={classNames('flex items-start rounded', className)} id={id}>
    {showIcon && (
      <Icon
        id={`${id}_icon`}
        className="flex-initial mt-px"
        icon="ExclamationCircle"
        color={color}
      />
    )}

    <p className={`px-2.5 text-${size} flex-1 text-${color}`} id={`${id}_text`}>
      {message}
    </p>
  </div>
);

InfoPanel.propTypes = {
  /** Class name */
  className: PropTypes.string,
  /** Icon and text color */
  color: PropTypes.string,
  /** id for reference */
  id: PropTypes.string,
  /** Panel message text */
  message: PropTypes.string.isRequired,
  /** Font size */
  size: PropTypes.oneOf(['xs', 'sm']),
};

export default InfoPanel;
